export enum eCancellationRequestStatus {
  Pending = 'PENDING',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
}
